// extracted by mini-css-extract-plugin
module.exports = {"root":"MainPageSectionList_root__JCgNc","listContainer":"MainPageSectionList_listContainer__FeUXg"};